import { render } from "./Purchase.vue?vue&type=template&id=20a9b5c6&scoped=true&ts=true&lang=pug"
import script from "./Purchase.vue?vue&type=script&lang=ts"
export * from "./Purchase.vue?vue&type=script&lang=ts"

import "./Purchase.vue?vue&type=style&index=0&id=20a9b5c6&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20a9b5c6"]])

export default __exports__